<template>
  <div>
    <action-header
      v-if="!hasValidRole(role, [Role.Student, Role.Family])"
      :button="buttonSearch"
      :data.sync="studentCode"
      @studentValue="studentCode = $event"
      :pathConnect="pathConnect"
      :validationColumn="validationColumn"
      @export-pdf="exportPdf()"
      :show-export="showExport"
      ref="actionHeader"
    >
    </action-header>
    <div v-else class="md-layout hidden lg:block">
      <div class="md-layout-item text-right">
        <md-button
          class="md-warning"
          @click.prevent="exportPdf()"
          v-if="showExport"
        >
          {{ $t("common.export") }}
        </md-button>
      </div>
    </div>
    <student-information :data="infoStudent">
      <md-card class="rounded-xl">
        <md-card-header class=" md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">
              {{ $t("smi_sri.physical_performance_mesuare_detail") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div v-if="physicalPerformanceTable">
            <md-table class="format-table md-scrollbar">
              <md-table-row>
                <md-table-head class="crossed px-0">
                  <div class="cross-cell">
                    <span class="test-date">{{ $t("smi_sri.test_date") }}</span>
                    <span class="type float-right">{{
                      $t("smi_sri.type")
                    }}</span>
                  </div>
                </md-table-head>
                <md-table-head
                  class="px-0"
                  v-for="(item, index) in tableHeaders"
                  :key="index + 'table-physical'"
                >
                  <span class="pl-3">{{ $t(item) }}</span>
                </md-table-head>
              </md-table-row>

              <template>
                <md-table-row
                  class="text-center"
                  v-for="(scoreTable, index) in physicalPerformanceTable"
                  :key="index + 'scoreTable'"
                >
                  <md-table-cell
                    >{{ convertDateFromServer(scoreTable.testDate, "date") }}
                  </md-table-cell>
                  <md-table-cell
                    >{{ scoreTable.benchpressInPounds }}
                  </md-table-cell>
                  <md-table-cell
                    >{{ scoreTable["40YardDashInSeconds"] }}
                  </md-table-cell>
                  <md-table-cell>{{
                    scoreTable.verticalJumpInInches
                  }}</md-table-cell>
                  <md-table-cell>{{ scoreTable.squatInPounds }}</md-table-cell>
                  <md-table-cell>{{ scoreTable.heightInInches }}</md-table-cell>
                  <md-table-cell>{{ scoreTable.weightInPounds }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.bodyMassIndexInPercentage
                  }}</md-table-cell>
                </md-table-row>
              </template>
            </md-table>
          </div>
          <div v-else>
            <no-data-found></no-data-found>
          </div>
        </md-card-content>
      </md-card>
    </student-information>
    <div v-if="showExport">
      <pdf-default ref="pdfContent" pdf-format="letter">
        <template #pdf-content>
          <export-pdf-physical
            :info="infoStudent"
            :data-table="physicalPerformanceTable"
          ></export-pdf-physical>
        </template>
      </pdf-default>
    </div>
  </div>
</template>
<script>
import ActionHeader from "./ActionHeader";
import StudentInformation from "../Components/StudentInfomation";
import AWSConst from "@/constants/AWS";
import { service_names } from "@/constants/Services";
import { convertObj, Message, getId } from "@/helpers/utils";
import pick from "lodash/pick";
import { mapGetters, mapState } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import PdfDefault from "../../../components/PdfDefault";
import ExportPdfPhysical from "./ExportPdfPhysical";

const tableHeadersDefault = [
  "smi_sri.benchpress_in_prounds",
  "smi_sri.40_yard_dash_in_seconds",
  "smi_sri.vertical_jump_in_inches",
  "smi_sri.squat_in_pounds",
  "smi_sri.height_in_inches",
  "smi_sri.weight_in_pounds",
  "smi_sri.body_mass_index_in_percentage"
];
export default {
  components: {
    ExportPdfPhysical,
    PdfDefault,
    StudentInformation,
    ActionHeader
  },
  data() {
    return {
      Role,
      hasValidRole,
      buttonSearch: {
        title: "common.search",
        action: this.getPhysicalPerformanceStudentInfo
      },
      data: null,
      studentCode: null,
      physicalPerformanceTable: null,
      infoStudent: null,
      //config import xlsx
      pathConnect: {
        templateLinks: `${service_names.school}/physical-performance-measures/template`,
        templateName: "template-physical-performance-measures.xlsx",
        pathSaveUploadedLink: `${service_names.school}/physical-performance-measures/import`,
        S3ImportACTPath: AWSConst.S3_IMPORT_PHYSICAL_PERFORMANCE_PATH
      },
      validationColumn: {
        validations: {}
      },
      showExport: false,
      convertDateFromServer,
      tableHeaders: tableHeadersDefault
    };
  },
  watch: {
    studentCode: function() {
      this.infoStudent = null;
      this.physicalPerformanceTable = null;
      this.showExport = false;
    }
  },
  computed: {
    ...mapState("switchAccountChild", ["currentChild"]),
    ...mapGetters("user", ["role", "info"])
  },
  mounted() {
    if (hasValidRole(this.role, Role.Student)) {
      this.studentCode = getId(this.info);
      this.getPhysicalPerformanceStudentInfo();
    }

    if (hasValidRole(this.role, Role.Family)) {
      this.studentCode = getId(this.currentChild);
      this.getPhysicalPerformanceStudentInfo();
    }

    const query = this.$route.query;
    if (
      !hasValidRole(this.role, Role.Student) &&
      query.tabName === "physical"
    ) {
      this.setInfoStudentByQuery(query);
      this.$router.replace({ query: {} });
    }
  },
  methods: {
    async setInfoStudentByQuery(query) {
      this.studentCode = query.id;
      await this.getPhysicalPerformanceStudentInfo();
    },
    getPhysicalPerformanceStudentInfo() {
      const studentCode = this.studentCode;
      if (!studentCode) {
        Message.error(
          this.$t("smi_sri.please_select_the_student_to_view_report")
        );
        return;
      }
      return this.$axios
        .get(
          `${service_names.school}/user/${studentCode}/report/physical-performance-measures`
        )
        .then(response => {
          if (!response.data) return;
          const data = convertObj.snakeCaseToCamelCase(response.data);
          this.infoStudent = pick(data, [
            "avatarUrl",
            "studentCode",
            "fullName",
            "grade"
          ]);
          if (!hasValidRole(this.role, [Role.Student, Role.Family])) {
            this.$refs.actionHeader.studentData.displayValue =
              this.infoStudent.fullName +
                " - " +
                this.infoStudent.studentCode || "";
          }
          if (data.physicalPerformance.length) {
            this.physicalPerformanceTable = data.physicalPerformance;
            this.showExport = true;
          }
        });
    },
    exportPdf() {
      this.$refs.pdfContent.generatePdf();
    }
  }
};
</script>
